import React from "react";
import OmniChannelDetailTab from "../OmniChannelDetailTab/OmniChannelDetailTab";

const OmniTabManager = () => {
  return <OmniChannelDetailTab />;
};

export default OmniTabManager;
